import React from 'react'

export const Alerta = ({titulo,texto,tipo,children}) => {
  return (
    <>
        <div className={`alert alert-dismissible bg-light-${tipo} d-flex flex-column flex-sm-row p-5 mb-10`}>
            <i className={`ki-duotone ki-notification-bing fs-2hx text-${tipo} me-4 mb-5 mb-sm-0`}>
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
            </i>
            <div className="d-flex flex-column pe-0 pe-sm-10">
              <h4 className="fw-semibold">{titulo}</h4>
              <span>{texto}</span>
              {children}
            </div>
            <button
                type="button"
                className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                data-bs-dismiss="alert"
                >
                <i className={`ki-duotone ki-cross fs-1 text-${tipo}`}>
                    <span className="path1" />
                    <span className="path2" />
                </i>
            </button>
        </div>
    </>

  )
}
